<template>
  <div class="Purchrecord">
    <div class="card">
      <div class="time">
        <span class="time_shijian">{{ purows.createTime }}</span>
        <span class="time_zhuangtai">{{ getOrderTypeDesc(purows) }}</span>
      </div>
      <div class="xiangqing">
        <div class="orderNo">
          <div>订单编号：{{ purows.orderNo }}</div>
          <img
            class="copyIcon"
            @click.stop="issucopy(purows.orderNo)"
            src="@/assets/icons/copy.png"
            alt=""
          />
        </div>
        <p>云手机套餐：{{ purows.packageName }}</p>
        <!-- <p>
          优惠券：{{
            purows.couponType == 1
              ? purows.couponAmount
                ? purows.couponAmount + "元优惠券"
                : "未使用优惠券"
              : purows.couponDiscount
              ? purows.couponDiscount + "折扣券"
              : "未使用优惠券"
          }}
        </p> -->
        <p>购买数量：{{ purows.buyCount }}台</p>
        <p>
          购买状态：{{
            purows.orderSource == "6" ? "定金支付成功" : purows.orderDesc
          }}
        </p>
        <div class="jine">
          <div v-show="purows.couponType" class="jineTop">
            ¥
            {{ originalSalePrice(purows.salePrice) }}
            <div class="jineNot"></div>
          </div>
          <div class="jineBottom">
            ¥
            <span>{{ xiaoshu[0] }}.</span>
            {{ xiaoshu[1] }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "Purchrecord",
  props: {
    purows: {},
  },
  data() {
    return {
      xiaoshu: "",
    };
  },

  mounted() {
    let str = (this.purows.totalAmount + "").indexOf(".");
    if (str == -1) {
      this.xiaoshu = (this.purows.totalAmount + ".0").split(".");
    } else {
      this.xiaoshu = (this.purows.totalAmount + "").split(".");
    }
  },
  computed: {
    originalSalePrice: {
      get() {
        return function (salePrice) {
          let _salePrice = null;
          let str = (salePrice + "").indexOf(".");
          if (str != -1) {
            _salePrice = salePrice + "";
          } else {
            _salePrice = salePrice + ".0";
          }
          return _salePrice;
        };
      },
    },
    getOrderTypeDesc: {
      get() {
        return function (item) {
          let data = item.orderTypeDesc;
          if (item.orderSource == "6") {
            data = "定金";
          } else if (item.orderSource == "7") {
            data = "尾款-" + item.orderTypeDesc;
          }
          return data;
        };
      },
    },
  },

  methods: {
    // 复制
    issucopy(orderNo) {
      this.$common.copy(orderNo, "复制成功!");
    },
  },
};
</script>
  
  <style lang="less" scoped>
.Purchrecord {
  width: calc(100%);
  padding: 12px 16px 0 16px;
  .card {
    // height: 172px;
    width: 100%;
    padding: 14px 0;
    background: #fff;
    border-radius: 12px;
    p {
      margin: 0;
      font-size: 14px;
    }
    .time {
      height: 26px;
      display: flex;
      align-items: center;
      padding: 0 20px 14px 20px;
      border-bottom: 1px solid rgb(239, 239, 239);
      .time_shijian {
        flex: 1;
        text-align: left;
      }
      .time_zhuangtai {
        color: #886df3;
        font-family: 思源黑体;
        font-size: 15px;
        font-weight: 400;
        line-height: 22px;
        letter-spacing: 0px;
        text-align: right;
      }
    }
    .xiangqing {
      position: relative;
      margin-top: 12px;
      padding: 0 20px;
      text-align: left;
      .orderNo {
        display: flex;
        align-items: center;
        .copyIcon {
          width: 15px;
          height: 15px;
          margin-left: 2px;
        }
      }

      p {
        margin-top: 10px;
      }
      .jine {
        position: absolute;
        // height: 34px;
        bottom: 0px;
        right: 20px;
        letter-spacing: 0px;
        text-align: right;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .jineTop {
          color: #999;
          font-size: 16px;
          position: relative;
          .jineNot {
            width: 70%;
            height: 1px;
            background-color: #999999;
            position: absolute;
            top: 50%;
            right: -3px;
            transform: translateY(-50%);
          }
        }
        .jineBottom {
          font-weight: 700;
          font-size: 16px;
          font-family: DIN;
          color: rgb(255, 87, 25);
        }
        span {
          font-size: 28px;
        }
      }
    }
  }
}
</style>